import styled from 'styled-components';
import { Theme } from '@veneer/theme';
import { Card } from '@veneer/core';

export const DoNotSeeDeviceContainer = styled.div<{ $veneerTheme: Theme }>`
  display: flex;
  justify-content: center;
`;

export const StyledCard = styled(Card)<{ $veneerTheme: Theme }>`
  width: 100%;
  overflow: hidden;
  max-width: calc(
    (
        ${({ $veneerTheme }) => $veneerTheme.layout.size8} +
          ${({ $veneerTheme }) => $veneerTheme.layout.size1}
      ) * 36
  );
`;

export const ContentContainer = styled.div<{ $veneerTheme: Theme }>`
  display: flex;
  flex-direction: column;
  padding: ${({ $veneerTheme }) => $veneerTheme.layout.size6};
`;

export const HeaderContainer = styled.div<{ $veneerTheme: Theme }>`
  display: flex;
  align-items: center;
  margin-bottom: ${({ $veneerTheme }) => $veneerTheme.layout.size6};
`;

export const RowButton = styled.button<{ $veneerTheme: Theme }>`
  width: 100%;
  color: ${({ $veneerTheme }) => $veneerTheme.color.foreground.medium};
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border: none;
  background: transparent;
  text-align: left;
  padding: ${({ $veneerTheme }) => $veneerTheme.layout.size4} 0;
  &:hover {
    background-color: ${({ $veneerTheme }) => $veneerTheme.color.gray2};
  }
  &:focus {
    outline: calc(${({ $veneerTheme }) => $veneerTheme.layout.size1} / 2) solid
      ${({ $veneerTheme }) => $veneerTheme.color.primary.base.active};
    outline-offset: ${({ $veneerTheme }) => $veneerTheme.layout.size1};
  }
`;

export const Divider = styled.div<{ $veneerTheme: Theme }>`
  height: calc(${({ $veneerTheme }) => $veneerTheme.layout.size1} / 4);
  background-color: ${({ $veneerTheme }) =>
    $veneerTheme.color.stroke.decorative.default};
`;

export const RowContent = styled.div<{ $veneerTheme: Theme }>`
  display: flex;
  align-items: center;
  gap: ${({ $veneerTheme }) => $veneerTheme.layout.size3};

  svg {
    fill: ${({ $veneerTheme }) => $veneerTheme.color.foreground.light};
  }
`;
